import React from "react";
import { Helmet } from "react-helmet";

import Program from "../components/Program";
import About from "../components/About";
import Tickets from "../components/Tickets";
import Faq from "../components/Faq";

// Haal dezelfde festival-gegevens op als in de Header
import { getFestivalInformation } from "../utils/extractConfigData";
import { LeafRed, FlowerOrangePlant, FlowerBluePlant } from "../components/Artwork";
import styles from "./Home.module.css";

const HomePage = () => {
  const festivalInformation = getFestivalInformation();

  return (
    <div className={styles.homePage}>
      {/* Artwork components positioned directly in container with viewport-relative positioning */}
      <div className={styles.artworkContainer}>
        <LeafRed className={styles.artMidLeft} style={{position: 'absolute', zIndex: 1}} />
        <LeafRed className={styles.artMidRight} style={{position: 'absolute', zIndex: 1}} />
        <FlowerBluePlant className={styles.artBottomLeft} style={{position: 'absolute', zIndex: 1}} />
        <FlowerOrangePlant className={styles.artBottomRight} style={{position: 'absolute', zIndex: 1}} />
      </div>
      
      <Helmet>
        <title>{festivalInformation.title}</title>
      </Helmet>
      
      <Program />
      <About />
      <Tickets />
      <Faq />
    </div>
  );
};

export default HomePage;
